// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createReturnOrder, deleteReturnOrder, getReturnOrderApi, updateReturnOrder } from '../../api/ReturnOrderApi'; // Adjust the path as needed
import {
    getReturnOrderSuccess,
    getReturnOrderFailure,
    createReturnOrderSuccess,
    createReturnOrderFailure,
    updateReturnOrderSuccess,
    updateReturnOrderFailure,
    deleteReturnOrderSuccess,
    deleteReturnOrderFailure,
    getAllReturnOrderSuccess,
    getAllReturnOrderFailure,
} from './actions';

// Saga to handle fetching ReturnOrders
function* fetchReturnOrderSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getReturnOrderApi, action.payload);
        yield put(getReturnOrderSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getReturnOrderFailure(errorMessage));
    }
}
// Saga to handle fetching ReturnOrders
function* fetchAllReturnOrderSaga(): Generator<any, any, any> {
    try {
        const data = yield call(getReturnOrderApi, {});
        yield put(getAllReturnOrderSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getAllReturnOrderFailure(errorMessage));
    }
}

// // Saga to handle creating a ReturnOrder
function* createReturnOrderSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createReturnOrder, action.payload);
        yield put(createReturnOrderSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createReturnOrderFailure(errorMessage));
    }
}

// // Saga to handle updating a ReturnOrder
function* updateReturnOrderSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateReturnOrder, action.payload.data, action.payload.id);
        yield put(updateReturnOrderSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateReturnOrderFailure(errorMessage));
    }
}

// // Saga to handle updating a ReturnOrder
function* deleteReturnOrderSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteReturnOrder, action.payload.id);
        yield put(deleteReturnOrderSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteReturnOrderFailure(errorMessage));
    }
}

export default function* ReturnOrderSaga() {
    yield takeEvery('GET_RETURN_ORDER_REQUEST', fetchReturnOrderSaga);
    yield takeEvery('GETALL_RETURN_ORDER_REQUEST', fetchAllReturnOrderSaga);
    yield takeEvery('CREATE_RETURN_ORDER_REQUEST', createReturnOrderSaga);
    yield takeEvery('UPDATE_RETURN_ORDER_REQUEST', updateReturnOrderSaga);
    yield takeEvery('DELETE_RETURN_ORDER_REQUEST', deleteReturnOrderSaga);
}
